import React, { useEffect, useState } from "react";
// Components
import Navbar from "../../components/Navbar";
import iconUser from "../../assets/user/account-circle.svg";
import { ImPlus } from "react-icons/im";
import ListUser from "../../components/ListUser";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";

export default function UserList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={iconUser} />
            <div>
              <S.Title>Usuário</S.Title>
              <S.Description>Cadastro geral de usuários</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-usuario")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />
            <S.Image src={iconUser} />
          </S.AddNew>
        </S.Header>

        <ListUser
          filter={params.get("filter") || ""}
          name={params.get("person") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
